import { ErrorListResponse, instanceOfErrorListResponse } from '@genial/services';
import { useEffect } from 'react';

import { useRecoilQuery } from '../../../../../hooks/useRecoilQuery';
import { useToastCreator } from '../../../../../hooks/useToastCreator';
import { customerByAccountNumberQuery } from '../../../../../store/customer/selector';
import { screenName } from '../constants';

interface CustomerProps {
  customerAccountNumber: number;
}

export const useCustomer = ({ customerAccountNumber }: CustomerProps) => {
  const { showToastFromError } = useToastCreator('customer-data-toast');

  const {
    data: customerData,
    error: customerDataIsError,
    loading: customerDataIsLoading,
  } = useRecoilQuery(
    customerByAccountNumberQuery({
      accountNumber: customerAccountNumber,
      currentScreen: screenName,
    })
  );

  useEffect(() => {
    if (customerDataIsError) {
      if (instanceOfErrorListResponse(customerDataIsError)) {
        (customerDataIsError as unknown as ErrorListResponse).errors?.forEach((errorItem) =>
          showToastFromError(errorItem)
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerDataIsError]);

  return { customerData, customerDataIsLoading, customerDataIsError };
};
